import React from "react";
import { Link } from "react-router-dom";

const AccessDenied = () => (
  <div className="puDashPage" dir="rtl" style={{ textAlign: "center", marginInline: "auto" }}>
    <h2>دسترسی مجاز نیست</h2>
    <p>این بخش برای نقش شما در دسترس نیست یا نشست منقضی شده است.</p>
    <Link to="/dashboard/getOrders">بازگشت به سفارش‌ها</Link>
    {" · "}
    <Link to="/signIn">ورود مجدد</Link>
  </div>
);

export { AccessDenied };
